import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import Panel from 'react-bootstrap/lib/Panel';
import ProfilePhoto from 'assets/img/default-profile.png';

import FormChangeEmail from './form-change-email';
import FormChangePassword from './form-change-password';
import { changeEmail, changePassword } from './actions';

class Account extends Component {
  _changeEmail = (formData) => {
    this.props.dispatch(changeEmail(formData));
  };
  _changePassword = (formData) => {
    this.props.dispatch(changePassword(formData));
  };

  render() {
    const { __me, __pending } = this.props;
    let photo = __me.get('photo');

    if (!photo) {
      photo = ProfilePhoto;
    }

    return (
      <div className='row'>
        <div className='col-sm-3'>
          <Panel header='Profile'>
            <div className='profile__header'>
              <img
                src={photo}
                alt={__me.get('full_name')}
                className='img-responsive img-circle'
              />
            </div>
            <div className='profile__name'>
              <div>{__me.get('full_name')}</div>
              <kbd>
                <small>{__me.get('id')}</small>
              </kbd>
            </div>
          </Panel>
        </div>
        <div className='col-sm-9'>
          <Panel header='Account Settings'>
            <FormChangeEmail
              email={__me.get('email')}
              id={__me.get('id')}
              pending={__pending}
              onSubmit={this._changeEmail}
            />
            <hr />
            <FormChangePassword
              pending={__pending}
              onSubmit={this._changePassword}
            />
          </Panel>
        </div>
      </div>
    );
  }
}

Account.propTypes = {
  __me: PropTypes.object,
  __pending: PropTypes.bool,
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    __me: state.auth.get('me'),
    __pending: state.auth.get('pending'),
  };
}

export default connect(mapStateToProps)(Account);



// WEBPACK FOOTER //
// ./src/containers/Account/index.js